import { Timeline as MantineTimeline } from '@mantine/core';

import { ITimeline } from 'types/timeline-types';
import TimelineEventItem from './TimelineEventItem';

interface IProps {
  events: ITimeline[];
}

const Timeline = ({ events }: IProps) => {
  return (
    <MantineTimeline bulletSize={30} lineWidth={5} align='left'>
      {events.map((event: ITimeline, index) => (
        <MantineTimeline.Item key={index} title={event.eventName}>
          <TimelineEventItem eventDetails={event} />
        </MantineTimeline.Item>
      ))}
    </MantineTimeline>
  );
};

export default Timeline;
